import { SVGProps } from "react";

const PdfFile = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="34"
    height="32"
    fill="none"
    viewBox="0 0 34 32"
  >
    <path
      fill="#fff"
      d="M15.02.375h4.8c.775 0 1.52.3 2.08.837l5.137 4.931v9.253a3.004 3.004 0 0 1-3.004 3.004H15.02a3.004 3.004 0 0 1-3.004-3.004V3.38A3.004 3.004 0 0 1 15.02.375"
    ></path>
    <path
      stroke="#E6E6E6"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="0.751"
      d="M27.037 6.143v9.253a3.004 3.004 0 0 1-3.004 3.004H15.02a3.004 3.004 0 0 1-3.004-3.004V3.38A3.004 3.004 0 0 1 15.02.375h4.8c.775 0 1.52.3 2.08.837zm0 0h-3.004a3.004 3.004 0 0 1-3.005-3.004V.736"
    ></path>
    <g filter="url(#a)">
      <rect
        width="15.772"
        height="6.253"
        x="9.012"
        y="8.633"
        fill="#DA3E52"
        rx="1.878"
        shapeRendering="crispEdges"
      ></rect>
      <path
        fill="#fff"
        d="M11.349 13.758V9.66h1.46q.479 0 .792.174t.47.476q.156.3.156.676 0 .379-.158.68-.156.301-.472.476t-.79.175h-1.004v-.524h.948q.302 0 .49-.104a.65.65 0 0 0 .276-.289.94.94 0 0 0 .088-.414.9.9 0 0 0-.088-.412.63.63 0 0 0-.278-.282 1.04 1.04 0 0 0-.496-.102h-.776v3.567zm5.154 0h-1.326V9.66h1.368q.602 0 1.034.246.433.245.662.702.233.457.233 1.095 0 .64-.235 1.1a1.64 1.64 0 0 1-.672.708q-.44.246-1.064.246m-.708-.54h.674q.468 0 .778-.176.31-.178.464-.514.154-.338.154-.825 0-.481-.154-.818a1.1 1.1 0 0 0-.454-.51q-.302-.174-.75-.174h-.712zm3.672.54V9.66h2.54v.532h-1.922v1.248h1.74v.53h-1.74v1.787z"
      ></path>
    </g>
    <defs>
      <filter
        id="a"
        width="33.799"
        height="24.275"
        x="-0.001"
        y="7.131"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        ></feColorMatrix>
        <feMorphology
          in="SourceAlpha"
          radius="2.253"
          result="effect1_dropShadow_56554_62104"
        ></feMorphology>
        <feOffset dy="7.511"></feOffset>
        <feGaussianBlur stdDeviation="5.633"></feGaussianBlur>
        <feComposite in2="hardAlpha" operator="out"></feComposite>
        <feColorMatrix values="0 0 0 0 0.00784314 0 0 0 0 0.00392157 0 0 0 0 0.0745098 0 0 0 0.1 0"></feColorMatrix>
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_56554_62104"
        ></feBlend>
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        ></feColorMatrix>
        <feMorphology
          in="SourceAlpha"
          radius="3.004"
          result="effect2_dropShadow_56554_62104"
        ></feMorphology>
        <feOffset dy="3.004"></feOffset>
        <feGaussianBlur stdDeviation="2.253"></feGaussianBlur>
        <feComposite in2="hardAlpha" operator="out"></feComposite>
        <feColorMatrix values="0 0 0 0 0.00784314 0 0 0 0 0.00392157 0 0 0 0 0.0745098 0 0 0 0.1 0"></feColorMatrix>
        <feBlend
          in2="effect1_dropShadow_56554_62104"
          result="effect2_dropShadow_56554_62104"
        ></feBlend>
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_56554_62104"
          result="shape"
        ></feBlend>
      </filter>
    </defs>
  </svg>
);
export default PdfFile;
